import { LockOpenOutlineIcon } from './LockOpenOutlineIcon';

/**
 * author: Google
 * id DCE8B967-BCDE-4130-8BF3-DDA78A78326F
 * name lock-open-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-outline.svg
 * tags
 * - Lock 
 * - Home Automation 
 * - Automotive 
 */
export const DecryptedOutlineIcon = LockOpenOutlineIcon;
export default DecryptedOutlineIcon